import { styled } from '@mui/material/styles';
import { css } from '@mui/material';
import { ClickConsumer } from '@/components/clickConsumer';

export const ViewerContainer = styled('div')`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0 0 0 / 0.65);
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;

  button {
    z-index: 5;
  }
`;

export const ImageContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'rotate' && prop !== 'zoom'
})<{ rotate: number; zoom: number }>`
  transform: ${(p) => `rotate(${p.rotate}deg) scale(${p.zoom})`};
  transition: transform 0.3s 0.1s;
  position: relative;
  max-height: 100%;
  max-width: 100%;
  height: fit-content;
  width: fit-content;
  cursor: move;

  img {
    display: inline-block;
    max-height: 100vh;
    max-width: 100%;
    height: 100%;
    width: 100%;
    object-fit: scale-down;
  }
`;

const BaseToolbar = styled(ClickConsumer, {
  shouldForwardProp: (prop) => prop !== 'visible'
})<{ visible: boolean }>`
  transition: opacity 0.3s linear;
  opacity: 0;
  display: flex;
  align-items: center;
  color: rgb(184, 199, 224) !important;
  position: fixed;
  width: 100%;
  z-index: 4;
  padding: 16px;

  ${(p) =>
    p.visible &&
    css`
      opacity: 1;
    `}
`;

export const TopToolbar = styled(BaseToolbar)<{ visible: boolean }>`
  justify-content: space-between;
  top: 0;
  left: 0;
  background-image: linear-gradient(rgb(26, 32, 46), rgba(26, 32, 46, 0));
  height: 96px;
`;
export const BottomToolbar = styled(BaseToolbar)<{ visible: boolean }>`
  bottom: 0;
  left: 0;
  gap: 18px;
  background-image: linear-gradient(
    to top,
    rgb(26, 32, 46),
    rgba(26, 32, 46, 0)
  );
  height: 72px;
  justify-content: center;
`;
